<template>
  <main>
    <HeaderNews
        buttonTitle="Editar"
        buttonTitle2="Excluir"
        title="Notícias"
        text="Cadastre suas notícias, adicione notícia e gerencie suas ações"
        :haveAction="false"
        :haveBack="false"
    />

    <!-- Modal deletar -->
    <v-dialog v-model="deleteDialog" v-if="currentNews && currentNews.title" max-width="420px">
      <DeleteModal
          title="Deletar"
          :textMessage="`Tem certeza que remover a notícia: ${currentNews.title}?`"
          cancelBtn="Cancelar"
          okbtn="Remover"
          textObservation=""
          icone="mdi-trash-can-outline"
          @close="(deleteDialog = false), listNews()"
          @action="(deleteDialog = false), remove()"
          @closeNoLoading="closeNoLoading"
          :key="dialogKey"
      />
    </v-dialog>

    <!-- Modal deletar -->
    <v-dialog v-model="notifyResalesDialog" v-if="currentNews && currentNews.id" max-width="420px">
      <ConfirmModal
          v-if="currentNews && currentNews.id"
          title="Notificar revendas"
          textMessage=""
          :textObservation1="`Deseja realmente notificar todas as revenda via e-mail?`"
          textObservation2=""
          cancelBtn="Cancelar"
          okbtn="Notificar"
          textObservation=""
          @close="(notifyResalesDialog = false)"
          @action="notifyResales()"
      />
    </v-dialog>

    <v-container style="max-width: unset" class="pa-4">
      <v-tabs
          class="pa-0 ma-0"
          background-color="#ECEEF1"
          grow
          height="35"
          hide-slider
      >
        <v-tab
            active-class="active-tab"
            class="tab"
            id="tab0"
            style="font-weight: bold !important"
            href="#mobile-tabs-5-0"
        >
          <span>Notícias</span>
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="activeTab">
        <v-tab-item
            :value="0"
            class="pa-0 ma-0"
            style="background-color: #eeeeee !important"
        >
          <v-card class="ma-0 pa-0">
            <!-- Cabeça -->
            <v-row class="pa-2 py-2 ma-0">
              <v-col
                  class="pa-0 ma-0"
                  cols="12"
                  md="6"
                  sm="6"
                  style="justify-content: space-around; align-self: end"
              >
                <p class="texto-p">
                  Gerencie e adicione novas notícias à plataforma
                </p>
              </v-col>

              <v-col
                  class="d-flex"
                  style="justify-content: flex-end; align-self: center"
                  cols="12"
                  md="6"
                  sm="6"
              >
                <v-btn
                    large
                    class="secondary-button float-right"
                    elevation="0"
                    @click="goToRoute('/cadastrar-noticia')"
                >
                  <span class="text-btn-add-banner">
                    Cadastrar notícia
                  </span>
                </v-btn>
              </v-col>
            </v-row>
          </v-card>

          <!-- Tabela1 -->
          <v-data-table
              ref="banner-table"
              :loading="loading"
              loading-text="Carregando..."
              no-data-text="Nenhum banner encontrado"
              :headers="headers"
              :items="banners"
              class="elevation-1 mytable mt-4 content-table"
              style="cursor: pointer"
              hide-default-footer
              :items-per-page="pageSize"
              :header-props="headerProps"
              :key="componentKey"
          >
            <template v-slot:[`item.image`]="{ item }" style="height: 100px">
              <div style="padding: 8px 0" class="justify-center align-center">
                <v-img
                    :src="item.image"
                    :alt="item.image"
                    class="imgBanner"
                    width="150"
                    height="75"
                ></v-img>
              </div>
            </template>

            <template v-slot:[`item.createdAt`]="{ item }">
              <div>
                {{ formatDate(item.createdAt) }}
              </div>
            </template>

            <template v-slot:[`item.updatedAt`]="{ item }">
              <div>
                {{ formatDate(item.updatedAt) }}
              </div>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <div class="d-flex">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        outlined
                        fab
                        tile
                        width="35"
                        height="35"
                        style="border-radius: 4px"
                        small
                        class="quinary-button ma-1"
                        color="quaternary"
                        @click="seeNews(item)"
                        v-bind="attrs"
                        v-on="on"
                    >
                      <v-icon dark>mdi-eye</v-icon>
                    </v-btn>
                  </template>
                  <span>Ver notícia</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        outlined
                        fab
                        tile
                        width="35"
                        height="35"
                        style="border-radius: 4px"
                        small
                        class="quinary-button ma-1"
                        color="quaternary"
                        @click="editNews(item)"
                        v-bind="attrs"
                        v-on="on"
                    >
                      <v-icon dark>mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                  <span>Editar</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        outlined
                        fab
                        tile
                        width="35"
                        height="35"
                        style="border-radius: 4px;"
                        small
                        class="ma-1 quinary-button"
                        color="red"
                        @click="deleteNews(item)"
                        v-bind="attrs"
                        v-on="on"
                    >
                      <v-icon dark>mdi-trash-can-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Remover</span>
                </v-tooltip>
              </div>
            </template>

            <template v-slot:[`item.notifyResellers`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                      outlined
                      fab
                      tile
                      small
                      class="btn-notifyResellers"
                      @click="showNotifyResales(item)"
                      v-bind="attrs"
                      v-on="on"
                  >
                    <v-icon size="20" dark>mdi-email-arrow-right-outline</v-icon>
                  </v-btn>
                </template>
                <span>Notificar revendas </span>
              </v-tooltip>
            </template>

            <template v-slot:footer class="ma-0 pa-0">
              <section class="ma-0 pa-0">
                <Pagination
                    v-if="totalItems > pageSize"
                    :currentPage="currentPage"
                    :totalItems="totalItems"
                    :page="page"
                    :pageSize="pageSize"
                    :totalPages="totalPages"
                    @back-page="backPage"
                    @next-page="nextPage"
                >
                </Pagination>
              </section>
            </template>
          </v-data-table>
        </v-tab-item>
      </v-tabs-items>
    </v-container>
  </main>
</template>

<style scoped>
.btn-notifyResellers {
  border: 1px solid #bc0000;
  border-radius: 4px!important;
  width: 35px!important;
  height: 35px!important;
  color: #bc0000!important;
}

.btn-notifyResellers:hover {
  background: #bc0000;
  color: #FFFFFF !important;
}

.text-btn-add-banner {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 21px;
  text-align: center;
  letter-spacing: 0.15px;
  color: #ffffff;
}

.imgBanner {
  background-position: center center;
  border-radius: 3px;
}

.title-g {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 40px;

  color: #000000;
}

.texto-p {
  font-family: Roboto;
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  line-height: 35px;
  color: #9c9c9c;
}

.active-tab {
  background: #2d3038;
  color: #ffffff !important;
}
</style>
<script>
import HeaderNews from "./components/HeaderNews.vue";

import DeleteModal from "../components/DeleteModal.vue";
import ApiService from "../../../services/ApiService";
import Utils from "../../../Utils/FormatDate";
import Vue from "vue";
import ConfirmModal from "@/views/pages/components/ConfirmModal.vue";
import Pagination from "@/views/pages/components/Pagination.vue";

export default {
  components: {
    ConfirmModal,
    Pagination,
    HeaderNews,
    DeleteModal,
  },
  data: () => ({
    dialogKey: false,
    banners: [],
    componentKey: false,
    deleteDialog: false,
    notifyResalesDialog: false,
    activeTab: 0,
    configs: [{label: "Criar Vitrine", value: 0}],
    closeNoLoading: false,
    env_url: "",
    currentNews: null,
    apiService: new ApiService(),
    loading: false,
    page: 1,
    sizes: [15, 30, 90, 180],
    totalPages: 1,
    totalItems: 1,
    currentPage: 1,
    pageSize: 10,
    filter: {
      page: 1,
      pageSize: 10,
    },
    headers: [
      {
        text: "Imagem principal",
        class: "item",
        value: "image",
        align: "center",
        sortable: false,
      },
      {
        text: "Titulo",
        class: "item",
        value: "title",
        align: "start",
        sortable: false,
      },
      {
        text: "Data do cadastrado",
        class: "item",
        value: "createdAt",
        align: "center",
        sortable: false,
      },
      {
        text: "Última atualização",
        class: "item",
        value: "updatedAt",
        align: "center",
        sortable: false,
      },
      {
        text: "Ações",
        class: "item",
        value: "actions",
        align: "center",
        sortable: false,
      },
      {
        text: "Notificar Revendas",
        class: "item",
        value: "notifyResellers",
        align: "center",
        sortable: false,
      },
    ],
    headerProps: {sortByText: "Ordenar por"},
  }),
  async created() {
    await this.listNews();

    this.env_url = process.env.VUE_APP_BASE_URL;
  },

  methods: {
    async seeNews(item) {
      this.currentNews = item;
      await this.$router.push({
        path: `noticia`,
        query: {id: item.id},
      });
    },

    async editNews(item) {
      this.currentNews = item;
      await this.$router.push({
        path: `cadastrar-noticia`,
        query: {id: item.id},
      });
    },

    async remove() {
      this.loading = true;
      await this.apiService
          .delete(`news/delete?id=${this.currentNews.id}`, )
          .then((resp) => {
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "success",
              title: "",
              message: "Notícia removido com sucesso",
              trace: null,
            });
            this.listNews();
            this.loading = false;
          })
          .catch((err) => {
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "error",
              title: "",
              message: "Não foi possível remover notícia selecionada.",
              trace: null,
            });

            this.loading = false;
          });
    },

    deleteNews(item) {
      this.currentNews = item;
      this.dialogKey = !this.dialogKey;
      this.deleteDialog = true;
    },

    formatDate(date) {
      return Utils.moment(date);
    },

    async listNews() {
      await this.apiService
          .post(`news/list`, this.filter)
          .then((response) => {
            const {content} = response
            this.totalPages = content.pager.totalPages;
            this.currentPage = content.pager.currentPage;
            this.pageSize = content.pager.pageSize;
            this.totalItems = content.pager.totalItems;
            this.banners = content.data;
            this.loading = false;
          });
    },

    async showNotifyResales(news) {
      this.notifyResalesDialog = true;
      this.currentNews = news;
    },

    async notifyResales() {
      this.notifyResalesDialog = false;
      await this.apiService
          .post(`news/notify_resales`, this.currentNews)
          .then((response) => {
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "success",
              title: "",
              message: "Revendas notificadas com sucesso",
              trace: null,
            });
          });
    },

    async backPage() {
      this.filter.page -= 1;
      this.page = this.filter.page;
      await this.listNews();
    },

    async nextPage() {
      this.filter.page += 1;
      this.page = this.filter.page;
      await this.listNews();
    },

    async goToRoute(route) {
      if (this.$route.path !== route) {
        await this.$router.push(route);
      }
    },

    showSuccess(message) {
      this.$emit("show", message);
    },
  },
  watch: {
  },
};
</script>
